<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb25 m-t-25 s_flex_bian_c">
        <a-button type="primary" v-has:salesmanLevelAdd="()=>{visiblerank=true}">
          <PlusOutlined />
          添加职级
        </a-button>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="名称" name='rank_name'>
          <a-input v-model:value="search.rank_name" placeholder="职级名称" />
        </a-form-item>
        <a-form-item label="创建日期" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_id' :columns='columns' :data-source='list' class="tableFixBox">
        <template v-slot:action="{ record }">
                <a-button type="primary" v-has:salesmanLevelEdit="()=>{visiblerank=true;rankId=record.id;rankform=JSON.parse(JSON.stringify(record))}" class="m-r-5">编辑</a-button>
                <a-button danger v-has:salesmanLevelDel="()=>del(record)" class="m-r-5" v-if="!record.status">删除</a-button>
 
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
    <a-modal :keyboard="false" :title="rankId?'修改职级':'添加职级'" centered :footer="null" v-model:visible="visiblerank" destroyOnClose @cancel='formLink={}'>
       <a-form :model='rankform'>
      <a-form-item ref="" label="职级" name="rank_name" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :rules="[{ required: true, message: '请输入职级'}]">
        <a-input v-model:value='rankform.rank_name' placeholder="职级名称" :maxlength="10"></a-input>
      </a-form-item>
      <a-form-item ref="" label="备注" name="remark" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-textarea v-model:value='rankform.remark'  placeholder="备注选填"></a-textarea>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
        <a-button type="primary" @click="rankId?edit():save()" :loading="confirmLoadingLink">
          保存
        </a-button>
      </a-form-item>
       </a-form>
    </a-modal>
  </a-layout>
</template>
<script>
import { DownOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { onMounted, ref } from "vue";
import { iscode } from "@/utils/app";

import {getBrandSaleRank,updateBrandSaleRank,delBrandSaleRank,createBrandSaleRank} from '@/api/salesman'
import useTableSearch from "@/hooks/useTableSearch";
import { message, Modal } from "ant-design-vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  rank_name: "",
  start_time: "",
  end_time: "",
};
const columns = [
  {
    title: "职级名称",
    dataIndex: "rank_name",
    key: "rank_name",
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components: {PlusOutlined },
  setup(props, ctx) {
    // 列表
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: JSON.parse(JSON.stringify(defSearch)) });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(getBrandSaleRank, search.value);
    });
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      tableHoosks.pageSearchChange();
    };
    //  地址 hooks
    const userRank = (api) => {
      const visiblerank = ref(false);
      const confirmLoadingLink = ref(false);
      const rankId = ref("");
      const rankform = ref({
        rank_name: "",
        remark: "",
      });
      const verifyform=()=>{
        if(!rankform.value){
          message.error("请输入职级")
          return  false
        }
        return true
      }
      const save = async () => {
        if(!verifyform())return
        confirmLoadingLink.value = true;
        let result = await createBrandSaleRank(rankform.value)
          .then((res) => res.data)
          .catch((error) => error);
        confirmLoadingLink.value = false;
        
        if (iscode(result, true)) {
          visiblerank.value=false
           // 重置一些数据
          rankform.value = { rank_name: "", remark: "" };
          search.value.page = 1;
          tableHoosks.pageSearchChange();
        }
      };
      const edit = async () => {
        if(!verifyform())return
        confirmLoadingLink.value = true;
        let result = await updateBrandSaleRank(rankId.value,{
          ...rankform.value,
          id: rankId.value,
        })
          .then((res) => res.data)
          .catch((error) => error);
        confirmLoadingLink.value = false;
        if (iscode(result, true)) {
          visiblerank.value=false
          // 重置一些数据
          search.value.page = 1;
          rankform.value = { rankform: "", sale_cat_name: "" };
          rankId.value=null
          tableHoosks.pageSearchChange();
        }
      };
      const del = (record) => {
        Modal.confirm({
          centered: true,
          content: "确定删除所选职级吗",
          onOk: async () => {
            let res = await delBrandSaleRank(record.id).then(
              (res) => res.data
            );
            if (iscode(res, true)) {
              search.value.page = 1;
              tableHoosks.pageSearchChange();
            }
          },
        });
      };
      return {
        visiblerank,
        rankform,
        save,
        edit,
        rankId,
        confirmLoadingLink,
        del,
      };
    };
    const rankHooks = userRank();
    return {
      ...tableHoosks,
      columns,
      ...rankHooks,
      onChange,
    };
  },
};
</script>